/*
 * © 2023 Vertafore, Inc. All rights reserved.
 * Reproduction and distribution without the written permission of Vertafore is prohibited.
 */
export const isDev = (): boolean => {
  return process.env.NODE_ENV === "development";
};
